import PropTypes from 'prop-types';
import clsx from 'clsx';

import useStyles from './styles';

function Label(props) {
  const classes = useStyles();
  const {
    children,
    className,
    color,
    onClick,
    variant,
  } = props;

  return (
    <span
      children={children}
      className={clsx(
        classes.root,
        (variant === 'uppercase' ? classes.uppercase : undefined),
        (onClick ? classes.isButton : undefined),
        {
          [classes[color]]: color,
        },
        className,
      )}
      onClick={onClick ? onClick : undefined}
    />
  );
}

Label.defaultProps = {
  className: '',
  color: 'secondary',
  variant: 'normal',
};

Label.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'error',
    'warning',
    'success',
  ]),
  onClick: PropTypes.func,
  style: PropTypes.object,
  variant: PropTypes.oneOf([
    'normal',
    'uppercase',
  ]),
};

export default Label;
